import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { RoundStatus, useTranslation } from '@pascal/pascal-core';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { autoBetDataKeys, globalTranslationKeys } from '../../../../../../enums';
import { doBetStore, gameStore } from '../../../../../../store';
import AutoBet from '../autoBet';

const BetButton = observer(({ decidedCallBackCall }) => {
  const t = useTranslation();
  const {
    isLoadingBetButton,
    currentWinOdd,
    betData: { isDisabled },
    updateIsDisabledBetSection,
    autoBetData,
    updateAutoBetData,
    doBetSender,
  } = doBetStore;
  const { activeFreeBet } = freeBetStore;

  const {
    limits: { defaultBetAmount, minBet },
  } = gameConfigStore;
  const {
    isBetsClosed,
    gameState: { status },
  } = gameStore;
  const { gameConfiguration = {} } = gameConfigStore;
  const { autobet: isAutoBetConfigEnabled = false } = gameConfiguration;
  const { Bet, Cancel, FreeBet, MinOdd } = globalTranslationKeys;
  const activeClassName = useMemo(() => {
    if (activeFreeBet?.id && activeFreeBet?.minOdd > currentWinOdd) {
      return 'disabled';
    }
    if (autoBetData.isAutoBet && autoBetData.autoBetCount) {
      return Cancel;
    }
    return Bet;
  }, [
    autoBetData.isAutoBet,
    autoBetData.autoBetCount,
    autoBetData.isOpened,
    isBetsClosed,
    currentWinOdd,
    activeFreeBet?.id,
    activeFreeBet?.minOdd,
  ]);

  useEffect(() => {
    if (Object.keys(activeFreeBet)?.length) {
      doBetStore.setBetAmount(activeFreeBet?.amount);
    } else {
      doBetStore.setBetAmount(defaultBetAmount || minBet);
      doBetStore.resetAutoBet();
    }
  }, [activeFreeBet]);

  const handleOnClick = () => {
    // if (isDemo && plus(Number(amount), Number(totalBetsAmount)) > Number(maxBet)) {
    //   notificationStore.setNotificationType({ responseCode: InValidMaxBet });
    // } else {
    decidedCallBackCall(() => {
      if (autoBetData.isAutoBet && autoBetData.autoBetCount && activeClassName === Cancel) {
        updateAutoBetData(autoBetDataKeys.isAutoBet, false);
        updateAutoBetData(autoBetDataKeys.autoBetCount, null);
        updateAutoBetData(autoBetDataKeys.isOpened, false);
        updateIsDisabledBetSection(false);
      } else {
        doBetSender();
      }
    });
    // }
  };

  return (
    <div
      className={`b-s-btn-right ${
        activeFreeBet?.id &&
        activeFreeBet?.minOdd < currentWinOdd &&
        !(isDisabled || isBetsClosed) &&
        !autoBetData.isAutoBet
          ? 'pulse-anim'
          : ''
      }`}
      onKeyDown={(e) => {
        if (isDisabled || isBetsClosed || isLoadingBetButton) {
          e.preventDefault();
        }
      }}
    >
      {isAutoBetConfigEnabled && (
        <AutoBet
          t={t}
          isBetAccepted
          autoBetData={autoBetData}
          doBetSender={doBetSender}
          currentWinOdd={currentWinOdd}
          isDisabledBetSection={isDisabled}
          isStart={status === RoundStatus.Started}
          handleChangeAutoBet={updateAutoBetData}
          activeFreeBetMinOdd={activeFreeBet?.minOdd}
          updateIsDisabledBetSection={updateIsDisabledBetSection}
        />
      )}
      <div
        className={`striker-btn-wrp ${
          (isDisabled || isBetsClosed) && !autoBetData.isAutoBet ? 'passive' : ''
        } ${isLoadingBetButton ? 'bet-loading' : ''}`}
        title={
          activeFreeBet?.id && !autoBetData?.isAutoBet
            ? `${t(FreeBet)}  ${activeFreeBet.remainingCount}`
            : t(activeClassName)
        }
        onClick={() => {
          if (!(activeFreeBet?.id && activeFreeBet?.minOdd > currentWinOdd)) {
            handleOnClick();
          }
        }}
      >
        <button className={`striker-btn ${activeClassName.toLowerCase()}`}>
          {/* add/remove cancel.disabled */}
          <p className='striker-btn-txt'>
            {activeFreeBet?.id && !autoBetData?.isAutoBet
              ? `${t(FreeBet)}  ${activeFreeBet.remainingCount}`
              : t(activeClassName)}
          </p>
          {activeFreeBet?.id && !autoBetData?.isAutoBet && !activeFreeBet.isMinOddNull ? (
            <p className='striker-btn-txt free-bet'>
              {activeFreeBet?.id ? `${t(MinOdd)} x${activeFreeBet?.minOdd}` : null}
            </p>
          ) : (
            <></>
          )}
          {isLoadingBetButton && <span className='circle-loader' />}
        </button>
      </div>
    </div>
  );
});

export default BetButton;
